module.exports = __webpack_public_path__ + "img/air_orange.60c69657.svg";